import { IconWrapper } from '../runtime';
export default IconWrapper('select-all', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.5 1.74976H3.25C2.42157 1.74976 1.75 2.42133 1.75 3.24976V4.49976M6 1.74976H10M11.5 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V4.49976M1.75 9.99976V6.01626M1.75 11.4998V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H4.5M14.25 6.01626V9.99976M14.25 11.4998V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H11.5M10 14.2498H6",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5 11.1289C5.36441 10.2667 8 4.49976 8 4.49976C8 4.49976 10.6356 10.2667 11 11.1289M5.72594 9.5H10.2741",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});